/**
 * Created by sebastienbeaujard on 26/04/2014.
 */

angular.module('FlexyBeautyApp.services').
    factory('Transaction', ["$timeout",
        function ($timeout) {

            var  Transaction = function ()
            {
                this.objects = [];
            }
            Transaction.prototype.addObject = function(object)
            {
                var index = this.objects.indexOf(object);
                if (index==-1)//Not already there
                    this.objects.push(object);
            }
            return Transaction;

        }]);


// WEBPACK FOOTER //
// ./js/services/tools/Transaction.js